document.addEventListener('DOMContentLoaded', function() {
  const originalButton = document.querySelector('.product-form__submit');
  if (!originalButton) return;

  // Get product information
  const productTitle = document.querySelector('.product__title, h1.product-title, .product-meta__title');
  const productPrice = document.querySelector('.price__container .price-item--regular, .product__price .price, .price');
  
  const isMobile = window.innerWidth <= 749;

  // Create sticky wrapper
  const stickyWrapper = document.createElement('div');
  stickyWrapper.className = 'sticky-atc-wrapper';
  stickyWrapper.style.cssText = `
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    background: rgb(var(--color-background));
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    padding: ${isMobile ? '12px 15px' : '15px 20px'};
    transform: translateY(100%);
    transition: transform 0.3s ease-in-out;
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  `;

  // Create content container for desktop
  if (!isMobile && productTitle) {
    const titleElement = document.createElement('div');
    titleElement.className = 'sticky-atc-title';
    titleElement.textContent = productTitle.textContent.trim();
    titleElement.style.cssText = `
      font-size: 16px;
      font-weight: 600;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
      min-width: 0;
    `;
    stickyWrapper.appendChild(titleElement);
  }

  // Clone and add button
  const stickyButton = originalButton.cloneNode(true);
  stickyButton.id = 'StickyATCButton';
  stickyButton.style.cssText = isMobile ? 'width: 100%;' : 'min-width: 200px;';
  stickyWrapper.appendChild(stickyButton);

  document.body.appendChild(stickyWrapper);

  // Helper to toggle sticky state + body class
  const setStickyState = (active) => {
    if (active) {
      stickyWrapper.style.transform = 'translateY(0)';
      stickyWrapper.style.pointerEvents = 'auto';
      document.body.classList.add('sticky-atc'); // body class for chat/app icons etc.
    } else {
      stickyWrapper.style.transform = 'translateY(100%)';
      stickyWrapper.style.pointerEvents = 'none';
      document.body.classList.remove('sticky-atc');
    }
  };

  // Function to check button visibility
  const checkButtonVisibility = () => {
    const buttonRect = originalButton.getBoundingClientRect();
    const isAboveViewport = buttonRect.bottom < 0;

    if (isAboveViewport) {
      setStickyState(true);
    } else {
      setStickyState(false);
    }
  };

  // Intersection Observer
  const observer = new IntersectionObserver((entries) => {
    checkButtonVisibility();
  }, { threshold: 0, rootMargin: '0px' });

  observer.observe(originalButton);

  // Scroll event listener
  window.addEventListener('scroll', checkButtonVisibility);

  // Button click handler
  stickyButton.addEventListener('click', function(e) {
    e.preventDefault();
    if (!originalButton.disabled) {
      originalButton.click();
    }
  });

  // Sync button state
  const syncButton = () => {
    stickyButton.disabled = originalButton.disabled;
    stickyButton.innerHTML = originalButton.innerHTML;
  };

  // Mutation observer for button state
  const buttonObserver = new MutationObserver(syncButton);
  buttonObserver.observe(originalButton, { 
    childList: true, 
    subtree: true, 
    attributes: true,
    attributeFilter: ['disabled']
  });

  // Initial sync + visibility check
  syncButton();
  checkButtonVisibility();

  // NOTE: removed window resize reload to avoid mobile reload/white flash issue
  // If you ever need to handle orientation change, you can add a light handler here
  // without using location.reload().
});


// Cart Drawer | Avoid page scroll While Drawer is opened

// Prevent body scroll when cart drawer is open
document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('cart-drawer');
  
  if (cartDrawer) {
    // When cart drawer opens
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          if (cartDrawer.classList.contains('active') || cartDrawer.classList.contains('is-open')) {
            // Prevent body scroll
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
          } else {
            // Restore body scroll
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
          }
        }
      });
    });
    
    observer.observe(cartDrawer, { attributes: true });
  }
  
  // Also handle the close button
  const closeButtons = document.querySelectorAll('.drawer__close, [data-close-drawer]');
  closeButtons.forEach(button => {
    button.addEventListener('click', function() {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    });
  });
});